import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/login/Login'
import Register from '@/components/login/Register'
import RegisterMs from '@/components/login/RegisterMs'
import ForgotPassword from '@/components/login/Forgot'
import ForgotMS from '@/components/login/ForgotMs'
import Dashboard from '@/components/projects/index'
import Plan from '@/components/plan/plan'
import photo from '@/components/photo/index'

import photoDocumentation from '@/components/photoDocumentation/components/PhotoDocumentsList'
import photoDocumentDetails from '@/components/photoDocumentation/components/PhotoDocumentsList'
import CreatePhotoDocument from '@/components/photoDocumentation/components/CreatePhotoDocument'

import ConstructionDiary from '@/components/constructionDiary/components/ConstructionDiaryListPage'
import EditCreateConstruction from '@/components/constructionDiary/components/EditConstructionReport'

import PdDashboard from '@/components/projects/PdDashboard'
import AppSetting from '@/components/appSetting/index'
import TasksList from '@/components/tasks/TasksList'
import CreateTask from '../components/tasks/CreateTask'

import Customers from '../components/customers/index'
import Customer from '../components/customer/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: Login,
      meta: { layout: 'default' }

    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { layout: 'default' }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: { layout: 'default' }

    },
    {
      path: '/RegisterMs',
      name: 'RegisterMs',
      component: RegisterMs,
      meta: { layout: 'default' }

    },
    {
      path: '/forgotpassword',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: { layout: 'default' }

    },
    {
      path: '/forgotMS',
      name: 'ForgotMS',
      component: ForgotMS,
      meta: { layout: 'default' }

    },
    {
      path: '/projects',
      name: 'Dashboard',
      component: Dashboard,
      meta: { layout: 'dashboard' }

    },
    {
      path: '/project/:id/photos',
      name: 'photo',
      component: photo,
      meta: { layout: 'plan' }

    },
    {
      path: '/project/:id/documentation/preport',
      name: 'photoDocumentation',
      component: photoDocumentation,
      meta: { layout: 'plan' }
    },
    {
      path: '/project/:id/documentation/preview/:docId/preport',
      name: 'photoDocumentationPreview',
      component: photoDocumentDetails,
      meta: { layout: 'plan' }
    },
    {
      path: '/project/:id/documentation/preport/:docId/edit',
      name: 'photoDocumentEdit',
      component: CreatePhotoDocument,
      meta: { layout: 'plan' }
    },
    {
      path: '/project/:id/documentation/create/preport',
      name: 'photoDocumentCreate',
      component: CreatePhotoDocument,
      meta: { layout: 'plan' }
    },
    {
      path: '/project/:id/construction-reports/list',
      name: 'constructionDocs',
      component: ConstructionDiary,
      meta: { layout: 'plan' }

    },
    {
      path: '/project/:id/construction-report/:reportId/preview',
      name: 'ConstructionReportPreview',
      component: ConstructionDiary,
      meta: { layout: 'plan' }

    },
    {
      path: '/project/:id/construction-report/:reportId/edit',
      name: 'editConstructionReport',
      component: EditCreateConstruction,
      meta: { layout: 'plan' }

    },
    {
      path: '/project/:id/tasks',
      name: 'tasksList',
      component: TasksList,
      meta: { layout: 'plan' }
    },
    {
      path: '/project/:id/tasks/create',
      name: 'createTask',
      component: CreateTask,
      meta: { layout: 'plan' }
    },
    {
      path: '/project/:id/plans',
      name: 'Plan',
      component: Plan,
      meta: { layout: 'plan' }

    },
    {
      path: '/project/:id/pdDashboard',
      name: 'PdDashboard',
      component: PdDashboard,
      meta: { layout: 'plan' }

    },
    {
      path: '/project/:id/settings',
      name: 'AppSetting',
      component: AppSetting,
      meta: { layout: 'plan' }
    },
    {
      path: '/customers',
      name: 'Customers',
      component: Customers,
      meta: { layout: 'customerdashboard' }
    },
    {
      path: '/customer/:customerid',
      name: 'Customer',
      component: Customer,
      meta: { layout: 'customer' }
    },
    {
      path: '/customer/:customerid/:area',
      name: 'Customerarea',
      component: Customer,
      meta: { layout: 'customer' }
    },
    {
      path: '/project/:id/tickets',
      name: 'Tickets',
      component: () => import('../components/tickets/index.vue'),
      meta: { layout: 'plan' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js